export default "__VITE_ASSET__J6XL_dY1__"